var ArticleVideo = function ArticleVideo(_ref) {
  var type = _ref.type,
    videoArticle = _ref.videoArticle;
  if (!videoArticle || type !== 'video') return null;
  var videoURL = videoArticle.videoURL;
  return /*#__PURE__*/React.createElement("div", {
    className: "a-video__wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "a-video__container"
  }, /*#__PURE__*/React.createElement("iframe", {
    width: "560",
    height: "349",
    frameBorder: "0",
    webkitAllowFullScreen: "",
    mozallowfullscreen: "",
    allowFullScreen: "",
    src: videoURL
  })));
};
export default ArticleVideo;